import type { PageHeadingProps } from "../types/layout.js";

export function PageHeading({ eyebrow, title, subtitle, action }: PageHeadingProps) {
  return (
    <header className="mb-8 flex flex-col justify-between gap-4 lg:mb-9 xl:flex-row xl:items-end">
      <div className="min-w-0">
        {eyebrow ? (
          <div className="mb-3 flex flex-wrap items-center gap-2 text-xs font-medium tracking-wide text-primary">
            {eyebrow}
          </div>
        ) : null}
        <h1 className="text-3xl font-medium tracking-tight text-foreground lg:text-4xl">{title}</h1>
        {subtitle ? (
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-secondary-text lg:text-base">{subtitle}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </header>
  );
}
